import React, { FC } from 'react';
import { Col } from 'react-bootstrap';
import thumbnail from '../../assets/img/someoneLikeYouThumbnail.jpg';

const VideoSelector: FC = () => {
  return (
    <>
      <div
        style={{
          background: 'linear-gradient(to bottom, #F7F7F7 0%, #EEEEEE 61%) repeat scroll 0 0 transparent',
          borderRadius: 5,
          border: '1px solid #C6C6C6',
        }}>
        <h3
          style={{
            color: '#FFFFFF',
            fontSize: '17px',
            padding: '10px 14px',
            borderRadius: '5px 5px 0 0',
            textAlign: 'start',
            background: 'linear-gradient(to bottom, #FFA860 16%, #FF7400 100%) repeat scroll 0 0 transparent',
          }}>
          Selecciona el video que m&aacute;s te guste
        </h3>

        <div
          style={{
            padding: '0 10px 24px 0',
            margin: '20px 10px 10px 10px',
          }}>
          <div
            style={{
              textAlign: 'start',
              marginBottom: 10,
            }}>
            <a
              href="#"
              style={{
                textDecoration: 'none',
              }}>
              <img
                style={{
                  width: '9.31rem',
                  height: '5.75rem',
                }}
                src={thumbnail}
                alt=""
              />
            </a>
          </div>

          <div>
            <h2
              style={{
                fontSize: '0.81rem',
                fontWeight: 'bold',
                textAlign: 'start',
              }}>
              <a
                href="#"
                style={{
                  textDecoration: 'none',
                  color: '#000',
                }}>
                Adele
              </a>
            </h2>
            <h4
              style={{
                fontSize: '0.69rem',
                fontWeight: 'normal',
                textAlign: 'start',
              }}>
              <a
                href="#"
                style={{
                  textDecoration: 'none',
                  color: '#646567',
                }}>
                Someone like you
              </a>
            </h4>
          </div>
        </div>
      </div>
    </>
  );
};

export default VideoSelector;
